
    import './styles.scoped.css';
    export default {
  "breadcrumb-group": "awsui_breadcrumb-group_d19fg_1mjwa_3",
  "item": "awsui_item_d19fg_1mjwa_14",
  "breadcrumb-group-list": "awsui_breadcrumb-group-list_d19fg_1mjwa_24",
  "ellipsis": "awsui_ellipsis_d19fg_1mjwa_34",
  "icon": "awsui_icon_d19fg_1mjwa_42",
  "mobile": "awsui_mobile_d19fg_1mjwa_46"
};
  